import { useCallback, useState } from 'react';
import { useTranslation } from 'next-i18next';

import { SchoolMapper } from '@/shared/category/util';

import { type CategoryNode } from '../../category-tree';

type PublisherCategoryError = {
  publisher?: string;
  customPublisher?: string;
};

export const useValidatePublisherCategory = () => {
  const [errors, setErrors] = useState<PublisherCategoryError>({});
  const { t } = useTranslation(['build']);

  const validate = useCallback(
    ({
      selectedPublisherNode,
      selectedCustomPublisher,
    }: {
      selectedPublisherNode?: CategoryNode;
      selectedCustomPublisher?: string;
    }): boolean => {
      const newErrors: PublisherCategoryError = {};
      let isValid = true;

      // 커스텀 출판사 검사
      if (SchoolMapper.isEtc(selectedPublisherNode?.nodeId)) {
        if (!selectedCustomPublisher) {
          newErrors.customPublisher = t('build:schoolInfo.requiredField');
          isValid = false;
        } else {
          const trimmed = selectedCustomPublisher.trim();
          if (trimmed.length < 2 || trimmed.length > 15) {
            newErrors.customPublisher = t('build:schoolInfo.requiredField');
            isValid = false;
          }
        }
      }

      setErrors(newErrors);
      return isValid;
    },
    [t],
  );

  const setError = (field: keyof PublisherCategoryError, message: string) => {
    setErrors(prev => ({ ...prev, [field]: message }));
  };

  const clearError = (field: keyof PublisherCategoryError) => {
    setErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[field as keyof typeof newErrors];
      return newErrors;
    });
  };

  return { errors, validate, setError, clearError };
};
